import { Bell } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { trpc } from "@/lib/trpc";
import { useCommunity } from "@/contexts/CommunityContext";
import { Button } from "@/components/ui/button";

export function NotificationsBell() {
  const { selectedCommunityId } = useCommunity();

  const { data: unreadData } = trpc.notification.getUnreadCount.useQuery(
    { communityId: selectedCommunityId! },
    {
      enabled: !!selectedCommunityId,
      refetchInterval: 30000,
    },
  );

  const unreadCount = unreadData?.count ?? 0;

  return (
    <Button asChild variant="ghost" size="icon" className="relative">
      <Link to="/notifications" aria-label="Notificaciones">
        <Bell className="h-5 w-5" />
        {unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-destructive text-xs font-medium text-destructive-foreground">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </Link>
    </Button>
  );
}
